import type { Api } from '../core/api';
import { log } from '../core/log';

/**
 * Tiendanube adapter — reads the logged-in customer from `window.LS`,
 * the Tiendanube/Nuvemshop client-side store. Auto-detects via either
 * the `LS` global or the hostname.
 */

export function detectTiendanube(): boolean {
	if (typeof window === 'undefined') return false;
	if ((window as any).LS) return true;
	if (typeof location === 'undefined') return false;
	const host = location.host || '';
	return /\.mitiendanube\.com$/.test(host) || /\.nuvemshop\.com\.br$/.test(host);
}

function readTiendanubeIdentity(): { id?: string; email?: string } {
	const w = window as any;
	const out: { id?: string; email?: string } = {};

	const ls = w.LS;
	if (ls && ls.customer) {
		if (ls.customer.id) out.id = String(ls.customer.id);
		if (typeof ls.customer.email === 'string') out.email = ls.customer.email;
	}

	// Some Tiendanube themes expose this directly on window.
	if (!out.email && typeof w.customer_email === 'string') out.email = w.customer_email;
	if (!out.id && (w.customer_id != null)) out.id = String(w.customer_id);

	return out;
}

export function installTiendanube(emblue: Api): void {
	if (!detectTiendanube()) return;
	log('tiendanube: adapter installed');
	const fire = () => {
		const ident = readTiendanubeIdentity();
		if (ident.id) emblue.identify(ident.id, ident.email ? { email: ident.email } : undefined, 'tiendanube');
		else if (ident.email) emblue.setEmail(ident.email, 'tiendanube');
	};
	fire();
	if (typeof document !== 'undefined' && document.readyState !== 'complete') {
		window.addEventListener('load', fire, { once: true });
	}
}
